import { AudienceCriteria } from '@appTypes/digital-audience/DigitalAudience';
import { Action } from '../../types/Action';

export enum DigitalAudienceInsightsActionsType {
  SET_DIGITAL_AUDIENCE_INSIGHTS_MODAL_OPENED = 'Set digital audience insights modal opened',
  SET_DIGITAL_AUDIENCE_INSIGHTS_ISSAVINGAUDIENCE = 'Set digital audience insights is saving audience',
  SET_DIGITAL_AUDIENCE_INSIGHTS_MODAL_STATE = 'Set dogota; audience insights modal state'
}

export const setDigitalAudienceInsightsModalOpened = (isOpened: boolean): Action => ({
  type: DigitalAudienceInsightsActionsType.SET_DIGITAL_AUDIENCE_INSIGHTS_MODAL_OPENED,
  payload: { isOpened: isOpened }
});

export const setDigitalAudienceInsightsIsSavingAudience = (isSavingAudience: boolean): Action => ({
  type: DigitalAudienceInsightsActionsType.SET_DIGITAL_AUDIENCE_INSIGHTS_ISSAVINGAUDIENCE,
  payload: { isSavingAudience: isSavingAudience }
});

export const setInsightsModelState = (
  totalAudience: number, 
  adAccount: any,
  audienceSelections: string,
  franchises: string,
  platform: string,
  selectedCriteria: AudienceCriteria[],
  storeCode: string | null): Action => ({
    type: DigitalAudienceInsightsActionsType.SET_DIGITAL_AUDIENCE_INSIGHTS_MODAL_STATE,
    payload: { 
      totalAudience: totalAudience, 
      adAccount: adAccount,
      audienceSelections: audienceSelections,
      franchises: franchises,
      platform: platform,
      selectedCriteria: selectedCriteria,
      storeCode: storeCode 
    }
});

export type DigitalAudienceInsightsActions = ReturnType<
| typeof setDigitalAudienceInsightsModalOpened
| typeof setDigitalAudienceInsightsIsSavingAudience
| typeof setInsightsModelState
>;
